import React from 'react';
import { useTheme } from '@mui/material';
import {
  ComposedChart,
  Line,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Label,
} from 'recharts';
import dayjs from 'dayjs';

const createDataPoint = (date: string, enquiries: number, bookings: number) => {
  return { date, enquiries, bookings };
};

const projectAllData = (data: any) => {
  if (!data) return [];
  const arr: any[] = [];
  data.forEach((element: any) => {
    arr.push(
      createDataPoint(
        dayjs(element.date).format('DD/MM'),
        element.enquiries,
        element.bookings
      )
    );
  });
  return arr;
};

interface Props {
  data: any[];
}

const StatsByDayChart: React.FC<Props> = ({ data }) => {
  const theme = useTheme();
  const chartData = projectAllData(data);
  return (
    <>
      <ResponsiveContainer width={'100%'} height={300}>
        <ComposedChart
          data={chartData}
          margin={{
            top: 16,
            right: 16,
            bottom: 0,
            left: 24,
          }}
        >
          <XAxis dataKey='date' stroke={theme.palette.primary.main} />
          <YAxis stroke={theme.palette.primary.main}>
            <Label
              angle={270}
              position='left'
              style={{ textAnchor: 'middle', fill: theme.palette.text.primary }}
            >
              Number
            </Label>
          </YAxis>
          <Tooltip />
          <Legend />
          <Bar dataKey='bookings' fill={theme.palette.primary.main} />
          <Line dataKey='enquiries' stroke={theme.palette.secondary.main} />
        </ComposedChart>
      </ResponsiveContainer>
    </>
  );
};

export default StatsByDayChart;
